import { Transition } from "@headlessui/react";
import {
  CheckCircleIcon,
  XCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { SUCCESS, ToastContext } from "../../context/ToastContext";

const Toast = () => {
  const { toastVisibility, toastTitle, toastContent, toastType, clear } =
    useContext(ToastContext);

  const timeOutRef = useRef(null);

  const [_toastVisibility, _setToastVisibility] = useState(false);
  const [_toastContent, _setToastContent] = useState(null);
  const [_toastTitle, _setToastTitle] = useState(null);
  const [_toastType, _setToastType] = useState(SUCCESS);

  const _clear = () => {
    _setToastTitle(null);
    _setToastContent(null);
    _setToastVisibility(false);
    _setToastType(SUCCESS);
  };

  useEffect(() => {
    return () => clearTimeout(timeOutRef.current);
  }, []);

  useEffect(() => {
    const update = () => {
      _setToastContent(toastContent);
      _setToastTitle(toastTitle);
      _setToastType(toastType);
      _setToastVisibility(true);
    };

    if (toastVisibility) {
      if (_toastContent !== null && toastContent !== _toastContent) {
        _setToastVisibility(false);
        timeOutRef.current = setTimeout(update, 1200);
      } else {
        update();
      }
    }
  }, [
    toastVisibility,
    toastContent,
    toastTitle,
    toastType,
    _toastContent,
    _setToastVisibility,
    _setToastContent,
    _setToastTitle,
    _setToastType,
  ]);

  return (
    <>
      <div
        aria-live="assertive"
        className="pointer-events-none fixed inset-0 z-50 flex items-end px-4 py-6 sm:items-start sm:p-6"
      >
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
          <Transition
            show={_toastVisibility}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    {_toastType === "success" ? (
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    ) : (
                      <XCircleIcon
                        className="h-6 w-6 text-red-400"
                        aria-hidden="true"
                      />
                    )}
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-gray-900">
                      {_toastTitle}
                    </p>
                    <p className="mt-1 text-sm text-gray-500">
                      {_toastContent}
                    </p>
                  </div>
                  <div className="ml-4 flex flex-shrink-0">
                    <button
                      className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      onClick={() => {
                        clear();
                        _clear();
                      }}
                      aria-label="Fermer la notification"
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  );
};

export default Toast;
